/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {
  Entity,
  Feature,
  GenericObject,
  ModuleActions
} from '@ion/core/src/types/entities';
import {
  Operation
} from '@ion/core/src/types/general';
import {ACTIONS} from './helpers';
import {PermissionsOptions} from './PermissionsUtils';

/**
 * Provide a reference to all pre-defined ADM Application features and sub features
 * for the ADM application.
 */
export const MODULES = {
  ADMIN_ACCOUNTS                     : 'Accounts',
  ADMIN_AEMP_CONFIG                  : 'AEMPConfig',
  ADMIN_APPLICATIONS                 : 'Applications',
  ADMIN_ASSETS                       : 'Assets',
  ADMIN_GROUPS                       : 'Groups',
  ADMIN_PEG_BEHAVIORS                : 'PEGBehavior',
  ADMIN_PEG_LABELS                   : 'PEGLabels',
  ADMIN_ROLES                        : 'Roles',
  ADMIN_USERS                        : 'Users',
  ADMIN_DEVICE_CONFIGS               : 'DeviceConfigs',
  ALERTS_NOTIFICATIONS               : 'AlertNotification',
  ALERTS_SETUP                       : 'AlertSetup',
  DEVICES                            : 'Devices',
  DASHBOARD_PAGE                     : 'DashBoard',
  PROVISIONING_DEVICE_FILES          : 'DeviceFiles',
  PROVISIONING_DOWNLOAD_JOBS         : 'Jobs',
  PROVISIONING_JOB_SEARCH_ENGINE     : 'JobSearchEngine',
  REPORTS_AVAILABLE_REPORTS          : 'AvailableReports',
  REPORT_MANAGER_PAGE                : 'ReportScheduler',
  SYSTEM_CONFIG_ALERT_TYPES          : 'AlertTypes',
  SYSTEM_CONFIG_APPLICATIONS         : 'SystemApplications',
  SYSTEM_CONFIG_CARRIERS             : 'Carriers',
  SYSTEM_CONFIG_DEVICE_TYPES         : 'DeviceTypes',
  TOOLBOX_KEYFILE_BUILDER            : 'KeyfileBuilder',
  TOOLBOX_MODBUS                     : 'ModBus',
  MANUFACTURED_DEVICES               : 'ManufacturedDevices',
  MANUFACTURING_INVENTORY            : 'ManufacturingInventory',
  MANUFACTURING_APPLICATION_IDS      : 'ManufacturingApplicationIds',
  MANUFACTURING_PART_NUMBERS         : 'ManufacturingPartNumbers',
  MANUFACTURING_SHIPMENTS            : 'ManufacturingShipments',
  VEHICLE_MANAGER                    : 'VehicleManager',
  VEHICLE_PROFILE                    : 'ProfileManager',
  OEM_VALIDATION_RULES               : 'Validation',
  FILE_PERMISSIONS_SCRIPT            : 'Script',
  FILE_PERMISSIONS_LMU_FW_CO_PRO     : 'LMUFirmwareAndCoProcessor',
  FILE_PERMISSIONS_VBUS              : 'Vbus',
  FILE_PERMISSIONS_BLUE_TOOTH        : 'Bluetooth',
  FILE_PERMISSIONS_RADIO_FW          : 'RadioFW',
  FILE_PERMISSIONS_HOSTED_EDGE_OPKGS : 'HostedAppAndEdgeAppAndOPKGS',
  FILE_PERMISSIONS_CUSTOMER_DB_FILES : 'CustomerDatabaseFiles',
  FILE_PERMISSIONS_MDT               : 'MDT',
  FILE_PERMISSIONS_KEY_FILES         : 'KeyFiles',
  SENSOR_INSTALLER                   : 'SensorInstaller'
};

/**
 * Define the module name with feature id associated.
 * todo -> This needs to be removed once the module action
 * clean up done(ADM-2853).
 */
export const MAP_MODULES_FEATURE_IDS = {
  'cbdf8164-d7bf-4032-a2e9-a99a10e006f8' : 'Accounts',
  'fcefbe1d-40b3-463f-85a3-239aa5d3188e' : 'AEMPConfig',
  '1972c656-b472-49e1-9ab0-ab0c69640455' : 'Applications',
  '56d5bc66-0782-4d59-8f88-0e6c683535f9' : 'Assets',
  'ffee852d-6627-4002-a67e-6ce27171b5b9' : 'Groups',
  '16099af0-d13d-4a4a-9dd7-39734a0aaede' : 'PEGBehavior',
  'dc20f01d-446a-4295-8e54-9b56fb992a1a' : 'PEGLabels',
  'f24d4d45-b0bf-4d8f-a8de-212dfcf5c685' : 'Roles',
  '926fd6ef-161e-43f5-8491-c2ea3861ece2' : 'Users',
  '45d19b6d-9356-4578-8f50-44a92582e2bb' : 'DeviceConfigs',
  'dfda6bc3-80b0-4a44-8b81-d0fb0e930e7f' : 'AlertNotification',
  'c1bc107c-4023-4c41-95c0-2509c0b3575f' : 'AlertSetup',
  '57f510b3-4b9c-4a63-bf26-337fd6bf3c58' : 'Devices',
  'd45d4cd5-6de4-428b-a946-477424d6f585' : 'DashBoard',
  '6f19aadf-40a7-426e-89eb-e7edbf598c0f' : 'DeviceFiles',
  '6916303b-9020-4b68-830f-160ce4d011eb' : 'Jobs',
  '49a543f7-6e64-48ff-98aa-8d1c5fa70e9c' : 'AvailableReports',
  '26e49e3f-e2d1-48ed-9edf-e4584f770c7f' : 'ScheduledReports',
  '320ceaff-851c-41ac-b5d3-60cd768228bb' : 'AlertTypes',
  'a9e8d8d2-ca04-4f28-89a7-cca03ea868b8' : 'SystemApplications',
  '81753b26-00a6-44af-bb34-ac0213c1ec7c' : 'Carriers',
  '697cb690-4834-4008-ba6e-3ffa18c26075' : 'DeviceTypes',
  '6d94c792-d32c-43b6-ba4f-2404c5e4e157' : 'KeyfileBuilder',
  'a83c7fd1-9e26-4b7d-b539-283d6b4f9c15' : 'ManufacturedDevices',
  'e92b6da4-7f36-2c1b-a849-793d6b5f2c46' : 'ManufacturingInventory',
  'b73d6fa2-1e96-4c7b-a539-283d6b4f9c15' : 'ManufacturingApplicationIds',
  'f93e8bd3-2b19-7c6b-a958-963d1b2c4f46' : 'ManufacturingPartNumbers',
  'ae052d7d-a242-f5ce-2bb6-2bef59f4a1b1' : 'ManufacturingShipments',
  'd5972faa-834c-4c1e-a18d-a42cf3e3cb80' : 'Script',
  '20e4f2b8-966c-4ac3-ba67-d2ea9c62d7da' : 'LMUFirmwareAndCoProcessor',
  '227eb22e-79e0-4072-917b-75e02526d9d7' : 'Vbus',
  '78bd342a-3af4-477d-8f45-a429353fbbda' : 'Bluetooth',
  '97f5dd2a-7112-4924-8311-1dab797cf5ef' : 'RadioFW',
  '4ad1dd42-4046-431a-8115-260ff597216d' : 'HostedAppAndEdgeAppAndOPKGS',
  '71bb275e-c8db-44ec-8eec-3c10b4a12a24' : 'CustomerDatabaseFiles',
  'c87350dc-851e-4bad-a60d-ce9dc1b62ad8' : 'MDT',
  '4f52d226-70f0-40e3-94b4-9b8549c4f829' : 'KeyFiles',
  '1bf27ac7-f091-4abb-99b8-15c9467d0fde' : 'VehicleManager',
  '3c2939ce-caee-4fa8-97e4-c66b61dc8a34' : 'ProfileManager',
  '1ddc6d62-62a9-496a-9de7-75f78320ccc5' : 'Validation',
  'fb2419cb-ef00-434d-8aa3-a46090bf15ff' : 'SensorInstaller',
  '6158d42d-4c26-4acc-a406-11dca2976a38' : 'ModBus'
};

/**
 * Alias for the application feature names which is having multiple words. Also the
 * Alerts and Reports are coming under 'AlertSetup' and 'AvailableReports' in ADM.
 * So the DOCTC/DOOC Reports and Alerts will be updated under modules as
 * 'AlertSetup' and 'AvailableReports' respectively.
 */
export const MODULE_ALIAS = {
  'AEMP Config'           : MODULES.ADMIN_AEMP_CONFIG,
  'Alert Types'           : MODULES.SYSTEM_CONFIG_ALERT_TYPES,
  Alerts                  : MODULES.ALERTS_SETUP,
  'Alerts Notification'   : MODULES.ALERTS_NOTIFICATIONS,
  'Alerts Setup'          : MODULES.ALERTS_SETUP,
  'Available Reports'     : MODULES.REPORTS_AVAILABLE_REPORTS,
  Dashboard               : MODULES.DASHBOARD_PAGE,
  'Device Configurations' : MODULES.ADMIN_DEVICE_CONFIGS,
  'Device Files'          : MODULES.PROVISIONING_DEVICE_FILES,
  'Device Types'          : MODULES.SYSTEM_CONFIG_DEVICE_TYPES,
  'Download Jobs'         : MODULES.PROVISIONING_DOWNLOAD_JOBS,
  'Job Search Engine'     : MODULES.PROVISIONING_JOB_SEARCH_ENGINE,
  'PEG Behaviors'         : MODULES.ADMIN_PEG_BEHAVIORS,
  'PEG Labels'            : MODULES.ADMIN_PEG_LABELS,
  'Scheduled Reports'     : MODULES.REPORTS_AVAILABLE_REPORTS,
  'Keyfile Builder'       : MODULES.TOOLBOX_KEYFILE_BUILDER,
  'Manufactured Devices'  : MODULES.MANUFACTURED_DEVICES,
  Inventory               : MODULES.MANUFACTURING_INVENTORY,
  'Application Ids'       : MODULES.MANUFACTURING_APPLICATION_IDS,
  'Part Numbers'          : MODULES.MANUFACTURING_PART_NUMBERS
};

const SINGLE_CHECKBOX_FEATURES = [
  MODULE_ALIAS.Dashboard,
  MODULE_ALIAS['Alerts Notification'],
  MODULE_ALIAS['Part Numbers'],
  MODULE_ALIAS['Application Ids'],
  MODULES.MANUFACTURED_DEVICES,
  MODULES.MANUFACTURING_SHIPMENTS
];

/**
 * Define all the file permissions features
 */
export const _filePermissions = [
  MODULES.FILE_PERMISSIONS_SCRIPT,
  MODULES.FILE_PERMISSIONS_LMU_FW_CO_PRO,
  MODULES.FILE_PERMISSIONS_VBUS,
  MODULES.FILE_PERMISSIONS_BLUE_TOOTH,
  MODULES.FILE_PERMISSIONS_RADIO_FW,
  MODULES.FILE_PERMISSIONS_HOSTED_EDGE_OPKGS,
  MODULES.FILE_PERMISSIONS_CUSTOMER_DB_FILES,
  MODULES.FILE_PERMISSIONS_MDT,
  MODULES.FILE_PERMISSIONS_KEY_FILES
];

/**
 * Define all the VES Features
 */
export const _VES_FEATURES = [
  MODULES.VEHICLE_MANAGER,
  MODULES.VEHICLE_PROFILE,
  MODULES.OEM_VALIDATION_RULES
];

/**
 * Define all the Sensor Features
 */
export const _SENSOR_FEATURES = [
  MODULES.SENSOR_INSTALLER
];

/**
 * Define the ModBus Asset Files Feature
 */
export const _MODBUS_FEATURES = [
  MODULES.TOOLBOX_MODBUS];

/**
 * Map the file permission feature and permissions.
 */
export const _mappedFilePremissions =  {
  [MODULES.FILE_PERMISSIONS_SCRIPT]            : [Entity.lmuscript],
  [MODULES.FILE_PERMISSIONS_LMU_FW_CO_PRO]     : [Entity.lmufirmware],
  [MODULES.FILE_PERMISSIONS_VBUS]              : [Entity.vbusconfig, Entity.vbusfirmware, Entity.vbushostedapp],
  [MODULES.FILE_PERMISSIONS_BLUE_TOOTH]        : [Entity.bluetoothfirmware],
  [MODULES.FILE_PERMISSIONS_RADIO_FW]          : [Entity.radiofirmware],
  [MODULES.FILE_PERMISSIONS_HOSTED_EDGE_OPKGS] : [
    Entity.custompackagesedgeapp,
    Entity.custompackageshostedapp,
    Entity.custompackagesopkg
  ],
  [MODULES.FILE_PERMISSIONS_CUSTOMER_DB_FILES] : [
    Entity.customerdatabasedriverid,
    Entity.customerdatabasegeozone,
    Entity.customerdatabaseapn
  ],
  [MODULES.FILE_PERMISSIONS_MDT]       : [Entity.mdtconfig, Entity.mdtfirmware],
  [MODULES.FILE_PERMISSIONS_KEY_FILES] : [Entity.lmudigitalsignature]
};

/**
 * Map the permissions and features.
 */
const mapFeaturePermissions = {
  [MODULES.ADMIN_APPLICATIONS]             : [Entity.application],
  [MODULES.ADMIN_ASSETS]                   : [Entity.asset],
  [MODULES.ADMIN_AEMP_CONFIG]              : [Entity.aemppollerconfigurator],
  [MODULES.PROVISIONING_DEVICE_FILES]      : [Entity.filemeta, Entity.customerfile],
  [MODULES.ADMIN_DEVICE_CONFIGS]           : [Entity.deviceconfiguration],
  [MODULES.DEVICES]                        : [Entity.device],
  [MODULES.ADMIN_ACCOUNTS]                 : [Entity.account],
  [MODULES.PROVISIONING_DOWNLOAD_JOBS]     : [Entity.jobs, Entity.job, Entity.task],
  [MODULES.PROVISIONING_JOB_SEARCH_ENGINE] : [Entity.jobs, Entity.job, Entity.task],
  [MODULES.REPORTS_AVAILABLE_REPORTS]      : [Entity.reports],
  [MODULES.ADMIN_PEG_LABELS]               : [Entity.peglabel],
  [MODULES.ADMIN_PEG_BEHAVIORS]            : [Entity.pegbehavior],
  [MODULES.ADMIN_ROLES]                    : [Entity.role],
  [MODULES.ADMIN_USERS]                    : [Entity.user],
  [MODULES.ADMIN_GROUPS]                   : [Entity.group],
  [MODULES.TOOLBOX_KEYFILE_BUILDER]        : [Entity.keyfilegenerator],
  [MODULES.TOOLBOX_MODBUS]                 : [Entity.filemeta, Entity.customerfile],
  [MODULES.MANUFACTURING_INVENTORY]        : [Entity.manufacturing],
  [MODULES.MANUFACTURED_DEVICES]           : [Entity.manufacturing],
  [MODULES.MANUFACTURING_APPLICATION_IDS]  : [Entity.appid, Entity.manufacturing],
  [MODULES.MANUFACTURING_PART_NUMBERS]     : [Entity.partnumber, Entity.manufacturing],
  [MODULES.MANUFACTURING_SHIPMENTS]        : [Entity.shipment],
  [MODULES.VEHICLE_MANAGER]                : [Entity.vin, Entity.vehicleidreport],
  [MODULES.VEHICLE_PROFILE]                : [Entity.vin],
  [MODULES.OEM_VALIDATION_RULES]           : [Entity.vin]
};

/**
 * Define the all action
 */
export const ALL_ACTION = 'All';

/**
 * show / hide checkbox for the Dashboard and
 * Notifications.
 */
const showHideCheckbox = (moduleName: string, action: any): boolean => {
  if (moduleName === MODULES.MANUFACTURING_INVENTORY) {
    return ![ACTIONS.ALL, ACTIONS.CREATE, ACTIONS.ASSIGN].includes(action);
  } if (!_filePermissions.includes(moduleName) && !SINGLE_CHECKBOX_FEATURES.includes(moduleName)) {
    return action !== ACTIONS.ASSIGN;
  }
  return SINGLE_CHECKBOX_FEATURES.includes(moduleName) ? action === ALL_ACTION : true;
};

/**
   * Device password is the additional module under the Devices feature.
   * Define the module name here to use while select / de-select the
   * device password module.
   */
export const DEVICE_PASSWORD = 'Device Password';

/**
   * VBus Enabled is the additional module under the Devices feature.
   * Define the module name here to use while select / de-select the
   * VBus Enabled module.
   */
export const VBUS_ENABLED_STATUS = 'VBus Enabled Status';

/**
 * hasJob method to Check job, jobs and task entity and return boolean.
 */
export const hasJobPermission = (Features) => {
  const hasJob  = Features?.hasPermission?.(PermissionsOptions.JOB, Operation.Create);
  const hasJobs = Features?.hasPermission?.(PermissionsOptions.JOBS, Operation.Create);
  const hasTask = Features?.hasPermission?.(PermissionsOptions.TASK, Operation.Create);
  return hasJob || hasJobs || hasTask;
};

/**
 * Check Assign Action.
 */
export const isAssignAction = (action): boolean => action?.toLowerCase() === Operation.Assign;

/**
 * checkPermissions method will Check for the job create,
 * and filemeta CRUD permission to enable / disable the actions
 * and return the boolean value accordingly.
 */
export const checkAllFeatureActions = ({
  Features,
  entities
}): GenericObject => {
  const hasCreateAccess = [];
  const hasReadAccess   = [];
  const hasUpdateAccess = [];
  const hasDeleteAccess = [];
  const hasAssignAccess = [];
  if (entities?.length) {
    entities?.forEach((entity) => {
      const hasCreate = Features?.hasPermission?.(entity, 'Create');
      const hasRead   = Features?.hasPermission?.(entity, 'Read');
      const hasUpdate = Features?.hasPermission?.(entity, 'Update');
      const hasDelete = Features?.hasPermission?.(entity, 'Delete');
      const hasAssign = Features?.hasPermission?.(entity, 'Assign');
      if (hasCreate) {
        hasCreateAccess.push(hasCreate);
      }
      if (hasRead) {
        hasReadAccess.push(hasRead);
      }
      if (hasUpdate) {
        hasUpdateAccess.push(hasUpdate);
      }
      if (hasDelete) {
        hasDeleteAccess.push(hasDelete);
      }
      if (hasAssign) {
        hasAssignAccess.push(hasAssign);
      }
    });
    return {
      Create : hasCreateAccess?.length,
      Read   : hasReadAccess?.length,
      Update : hasUpdateAccess?.length,
      Delete : hasDeleteAccess?.length,
      Assign : hasAssignAccess?.length
    };
  };
};

/**
 * Check All the actions and return true when all CRUD actions are true.
 */
export const isAllActionEnabled = (allActions: GenericObject, hasFilePermission = false): boolean => {
  const values = Object.values(allActions);
  const len    = hasFilePermission ? values?.length : values?.length -1;
  return values?.filter((item) => item)?.length === len;
};

/**
 * Generate the module Actions based on the conditions.
 * Example:
 * [
 *  {
 *    id      : 'Device-Create-1',
 *    name    : 'Create',
 *    enabled : false
 *  },
 *  {
 *    id      : 'Device-Read-2',
 *    name    : 'Read',
 *    enabled : false
 *  },
 *  {
 *    id      : 'Device-Update-3',
 *    name    : 'Update',
 *    enabled : false
 *  },
 *  {
 *    id      : 'Device-Delete-3',
 *    name    : 'Delete',
 *    enabled : false
 *   }
 * ]
 */
export const createModuleActions = ({
  Features,
  moduleName,
  actions,
  api,
  enableActionAlias = false
}): ModuleActions => {
  const modules                 = [];
  let featurePermissionActions  = {};
  const isFilePermissionFeature = _filePermissions.indexOf(moduleName) > -1;
  const isVESFeatures           = _VES_FEATURES.includes(moduleName);
  const isSensorsFeature        = _SENSOR_FEATURES.includes(moduleName);
  const isModbusFeature         = _MODBUS_FEATURES.includes(moduleName);
  const hasVESInternalRole      = api?.isUserHasInternalVESRole() || false;

  const entities = isFilePermissionFeature ? _mappedFilePremissions[moduleName] : mapFeaturePermissions[moduleName];
  featurePermissionActions = checkAllFeatureActions({
    Features,
    entities
  }) || {};
  
  actions?.forEach((action: ACTIONS, i: number) => {
    let hasPermission = action !== ALL_ACTION ? featurePermissionActions?.[action]
      : isAllActionEnabled(featurePermissionActions, isFilePermissionFeature);

    if (PROTECTED_MODULES.includes(moduleName)) {
      hasPermission = Features.hasPermission(MODULE_TO_PERMISSION_ENTITY[moduleName], Operation[action]);
    }

    if (DEFAULT_MODULES.includes(moduleName)) {
      hasPermission = true;
    }

    if (isVESFeatures) {
      const isProfile  =  moduleName === MODULES.VEHICLE_PROFILE;
      const actions    = [ACTIONS.ALL, ACTIONS.CREATE, ACTIONS.DELETE, ACTIONS.UPDATE];
      const restricted = isProfile ? [...actions, ACTIONS.READ] : actions;
      hasPermission    = !restricted.includes(action) ||
      Features.hasPermission(mapFeaturePermissions[MODULES.VEHICLE_MANAGER[moduleName]], Operation[action]);
      if (hasVESInternalRole) {
        const allowedActions = [ACTIONS.READ, ACTIONS.UPDATE];
        hasPermission = allowedActions.includes(action);
      }
    }

    if (isSensorsFeature) {
      const restricted = [ACTIONS.ALL, ACTIONS.CREATE, ACTIONS.DELETE];
      hasPermission = !restricted.includes(action);
    }

    if (isModbusFeature) {
      const modBusRestrictedActions = [ACTIONS.ALL, ACTIONS.DELETE];
      hasPermission = !modBusRestrictedActions.includes(action);
    }

    modules.push({
      id            : `${moduleName}-${action}-${i}`,
      name          : action,
      enabled       : enableActionAlias,
      hasPermission : hasPermission,
      showCheckBox  : showHideCheckbox(moduleName, action)
    });
  });
  return modules;
};

const PROTECTED_MODULES = [
  MODULES.MANUFACTURING_INVENTORY
];

const MODULE_TO_PERMISSION_ENTITY = {
  [MODULES.MANUFACTURING_INVENTORY] : Entity.manufacturing
};

const DEFAULT_MODULES = [
  MODULES.DASHBOARD_PAGE
];

/**
 * Define the additional device modules here.
 */
export const additionalDevicesModuleList = [{
  id            : 'Device-Password-All',
  name          : DEVICE_PASSWORD,
  enabled       : false,
  hasPermission : true,
  showCheckBox  : true
}, {
  id            : 'VBus-Enabled-All',
  name          : VBUS_ENABLED_STATUS,
  enabled       : false,
  hasPermission : true,
  showCheckBox  : true
}];

/**
 * check isVbusEnabledStatus is enabled
 */
export const isVbusAccessEnabled = (feature: Feature): boolean => {
  const modules = feature?.name === MODULES?.DEVICES ? feature?.modules : [];
  return modules?.find((item) => item.name === VBUS_ENABLED_STATUS && item.enabled === true);
};

/**
 * Get the additional device module based on the given role.
 */
export const getAdditionalDevicesModule = (feature, isViewMode, isVewBusEnabled) => {
  const deviceModules =  [...additionalDevicesModuleList];
  if (isViewMode) {
    isVewBusEnabled = isVbusAccessEnabled(feature);
  }
  if (!isVewBusEnabled) {
    const VbusIndex = deviceModules?.findIndex((item) => item.name === VBUS_ENABLED_STATUS);
    delete deviceModules?.[VbusIndex];
  }
  return deviceModules;
};
